<div class="animate-fade-in">
    <app-data-table [title]="isSuperAdmin() ? 'Usuarios del Sistema' : 'Colaboradores del Negocio'"
        [description]="isSuperAdmin() ? 'Directorio global de todos los usuarios registrados' : 'Gestiona los accesos y acciones permitidas para tu equipo'"
        icon="solar:users-group-rounded-bold-duotone" [loading]="loading()" (onReload)="userResource.reload()"
        [total]="total()" [dataSource]="displayUsers()" [columns]="columns" [pagination]="pagination()"
        (onSearch)="handleSearch($event)" (onPageChange)="handlePageChange($event)"
        (onLimitChange)="handleLimitChange($event)" [columnTemplates]="{
           'fullName': userTmpl,
           'email': emailTmpl,
           'status': statusTmpl,
           'actions': actionsTmpl
        }">

        <!-- Metrics Slot -->
        <ng-template #metrics>
            <app-metrics [items]="metricsItems()"></app-metrics>
        </ng-template>

        <ng-template #actionGroup>
            <app-button variant="glass" size="md" [square]="true" [spinIconOnHover]="true" class="p-2"
                routerLink="/app/users/new" [title]="isSuperAdmin() ? 'Nuevo Operador Core' : 'Invitar Colaborador'"
                iconLeft="mdi:plus">
            </app-button>
        </ng-template>

        <ng-template #userTmpl let-user>
            <div class="flex items-center gap-4">
                <div class="relative w-10 h-10">
                    <div
                        class="absolute inset-0 bg-primary/10 rounded-xl rotate-6 group-hover:rotate-12 transition-transform">
                    </div>
                    <div
                        class="w-full h-full flex items-center justify-center font-black text-[11px] text-primary bg-surface border border-primary/20 rounded-xl relative">
                        {{ getUserInitials(user.fullName) }}
                    </div>
                </div>
                <div class="flex flex-col">
                    <span class="text-foreground font-black tracking-tight leading-none text-[13px]">{{ user.fullName
                        }}</span>
                    <span *ngIf="user.isSuperAdmin"
                        class="text-[8px] font-black text-amber-500 uppercase tracking-widest mt-1 bg-amber-500/10 px-1.5 py-0.5 rounded-md w-fit">Super
                        Admin</span>
                </div>
            </div>
        </ng-template>

        <ng-template #emailTmpl let-user>
            <div class="flex flex-col">
                <span class="text-[12px] font-bold text-foreground/60 leading-none">{{ user.email }}</span>
                <span *ngIf="isSuperAdmin()" class="flex items-center gap-1 mt-1">
                    <iconify-icon [icon]="user.isEmailVerified ? 'solar:check-circle-bold' : 'solar:danger-circle-bold'"
                        [class]="user.isEmailVerified ? 'text-primary' : 'text-orange-500'" width="10"></iconify-icon>
                    <span class="text-[8px] font-black uppercase tracking-widest"
                        [class]="user.isEmailVerified ? 'text-primary/60' : 'text-orange-500/60'">
                        {{ user.isEmailVerified ? 'Verificado' : 'Pendiente' }}
                    </span>
                </span>
            </div>
        </ng-template>

        <ng-template #statusTmpl let-user>
            <div class="flex flex-col gap-1">
                <div class="flex items-center gap-2">
                    <div
                        [class]="'w-1.5 h-1.5 rounded-full ' + (user.isActive ? 'bg-emerald-500 shadow-[0_0_8px_rgba(16,185,129,0.5)]' : 'bg-foreground/20')">
                    </div>
                    <span class="text-[10px] font-black uppercase tracking-widest"
                        [class]="user.isActive ? 'text-foreground' : 'text-foreground/60'">
                        {{ user.isActive ? 'Visible' : 'Oculto' }}
                    </span>
                </div>
                <div class="flex items-center gap-2">
                    <iconify-icon
                        [icon]="user.status === 'active' ? 'solar:verified-check-bold' : (user.status === 'suspended' ? 'solar:danger-bold' : 'solar:clock-circle-bold')"
                        [class]="user.status === 'active' ? 'text-primary' : (user.status === 'suspended' ? 'text-red-500' : 'text-orange-500')"
                        width="12"></iconify-icon>
                    <span class="text-[9px] font-black uppercase tracking-widest"
                        [class]="user.status === 'active' ? 'text-primary' : (user.status === 'suspended' ? 'text-red-500' : 'text-orange-500')">
                        {{ user.status === 'active' ? 'Acceso OK' : (user.status === 'suspended' ? 'Suspendido' :
                        'Pendiente') }}
                    </span>
                </div>
            </div>
        </ng-template>

        <ng-template #actionsTmpl let-user>
            <div class="flex items-center justify-end gap-1">
                <app-button *ngIf="canManageUsers() && !user.isEmailVerified" variant="glass" size="xs" [square]="true"
                    (btnClick)="onResendClick(user)" class="p-1" iconLeft="solar:letter-bold-duotone"
                    title="Reenviar Verificación" color="text-orange-500"
                    hover="hover:text-orange-600 hover:border-orange-500/30 hover:bg-orange-500/5">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" (btnClick)="viewDetails(user)" class="p-1"
                    iconLeft="solar:eye-bold-duotone" title="Ver Detalles" color="text-blue-500"
                    hover="hover:text-blue-600 hover:border-blue-500/30 hover:bg-blue-500/5">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" color="text-green-500" class="p-1"
                    [routerLink]="['/app/users/edit', user.id]" iconLeft="solar:pen-new-square-linear" title="Editar"
                    hover="hover:text-green-600 hover:border-green-500/30 hover:bg-green-500/5">
                </app-button>
                <app-button variant="glass" size="xs" [square]="true" (btnClick)="deleteUser(user.id)" class="p-1"
                    iconLeft="solar:trash-bin-minimalistic-linear" title="Eliminar" color="text-red-500"
                    hover="hover:text-red-600 hover:border-red-500/30 hover:bg-red-500/5">
                </app-button>
            </div>
        </ng-template>

    </app-data-table>

    <!-- ── Modal de Detalles Ultra Compacto ────────────────────────────────────── -->
    <app-modal [isOpen]="showDetails()" (isOpenChange)="showDetails.set($event)"
        [title]="selectedUser() ? selectedUser()!.fullName : ''" icon="solar:user-id-bold-duotone">

        <div class="space-y-5 py-2" *ngIf="selectedUser() as user">
            <!-- ── 1. Identidad Operativa ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:user-circle-bold-duotone" width="12"></iconify-icon>
                    Identidad Operativa
                </p>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Nombre
                            Completo</span>
                        <span class="text-xs font-bold text-foreground">{{ user.fullName }}</span>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03]">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Correo
                            Acceso</span>
                        <span class="text-xs font-bold text-foreground">{{ user.email }}</span>
                    </div>
                </div>
            </div>

            <!-- ── 2. Seguridad y Estado de Acceso ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:shield-check-bold-duotone" width="12"></iconify-icon>
                    Seguridad y Estado de Acceso
                </p>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Acceso
                            Global Sistema</span>
                        <div class="flex items-center gap-1.5">
                            <iconify-icon
                                [icon]="user.status === 'active' ? 'solar:verified-check-bold' : 'solar:danger-bold'"
                                [class]="user.status === 'active' ? 'text-emerald-500' : 'text-red-500'"
                                width="12"></iconify-icon>
                            <span class="text-xs font-bold"
                                [class]="user.status === 'active' ? 'text-emerald-500' : 'text-red-500'">{{ user.status
                                === 'active' ? 'Permitido' : 'Suspendido' }}</span>
                        </div>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Atributo
                            SuperAdmin</span>
                        <div class="flex items-center gap-1.5">
                            <iconify-icon
                                [icon]="user.isSuperAdmin ? 'solar:shield-star-bold-duotone' : 'solar:user-id-linear'"
                                [class]="user.isSuperAdmin ? 'text-amber-500' : 'text-foreground/50'"
                                width="12"></iconify-icon>
                            <span class="text-xs font-bold"
                                [class]="user.isSuperAdmin ? 'text-amber-500' : 'text-foreground/60'">{{
                                user.isSuperAdmin ? 'Maestro' : 'Colaborador' }}</span>
                        </div>
                    </div>
                </div>
                <div class="grid grid-cols-2 gap-3">
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Visibilidad
                            General</span>
                        <span class="text-xs font-bold text-foreground flex items-center gap-1.5">
                            <div
                                [class]="'w-1.5 h-1.5 rounded-full ' + (user.isActive ? 'bg-emerald-500' : 'bg-foreground/20')">
                            </div>
                            {{ user.isActive ? 'Activada' : 'Inactiva' }}
                        </span>
                    </div>
                    <div class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-1">
                        <span
                            class="text-[9px] font-black uppercase tracking-widest text-foreground/60 block mb-1">Registrado</span>
                        <span class="text-xs font-bold text-foreground/70">{{ user.createdAt | date:'dd MMM, yyyy'
                            }}</span>
                    </div>
                </div>
            </div>

            <!-- ── 3. Permisos del Módulo de Sistema ── -->
            <div class="space-y-2">
                <p class="text-[9px] font-black uppercase tracking-widest text-primary/80 flex items-center gap-1">
                    <iconify-icon icon="solar:shield-keyhole-bold-duotone" width="12"></iconify-icon>
                    Permisos del Módulo de Sistema
                </p>

                <div class="grid grid-cols-1 gap-2 max-h-[220px] overflow-y-auto pr-1" *ngIf="!user.isSuperAdmin">
                    <div *ngFor="let mod of getModulePermissions(user)"
                        class="bg-surface-muted/50 p-3 rounded-xl border border-foreground/[0.03] space-y-2">
                        <div class="flex items-center gap-2">
                            <iconify-icon icon="solar:folder-with-files-bold-duotone"
                                class="text-primary text-sm"></iconify-icon>
                            <span
                                class="text-[10px] font-bold text-slate-800 dark:text-white/90 uppercase tracking-wider">{{
                                mod.module }}</span>
                        </div>
                        <div class="flex flex-wrap gap-1.5">
                            <div *ngFor="let act of mod.actions"
                                class="px-2 py-1 bg-primary/5 border border-primary/10 rounded-md flex items-center gap-1">
                                <iconify-icon icon="solar:check-circle-bold"
                                    class="text-primary text-[10px]"></iconify-icon>
                                <span class="text-[8px] font-bold text-foreground/80 uppercase">{{ act }}</span>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="!getModulePermissions(user).length" class="text-xs text-foreground/60 italic">Sin
                        permisos específicos configurados</div>
                </div>

                <div *ngIf="user.isSuperAdmin"
                    class="p-3 bg-amber-500/5 border border-amber-500/10 rounded-xl flex items-center gap-3">
                    <iconify-icon icon="solar:shield-star-bold-duotone" class="text-amber-500 text-lg"></iconify-icon>
                    <div class="flex flex-col">
                        <span class="text-xs font-black text-amber-500 uppercase">Acceso Total (SuperAdmin)</span>
                        <span class="text-[10px] text-foreground/50">Habilita la administración total de la
                            plataforma</span>
                    </div>
                </div>
            </div>
        </div>

        <div actions class="flex justify-end items-center gap-3 w-full">
            <app-button variant="glass" size="xs"
                [routerLink]="['/app/users/edit', selectedUser()?._id || selectedUser()?.id]" color="text-blue-500"
                iconLeft="solar:pen-new-square-bold" (btnClick)="showDetails.set(false)"
                class="text-[10px] font-black uppercase">
                Editar Usuario
            </app-button>
            <app-button variant="primary" size="xs" (btnClick)="showDetails.set(false)"
                iconLeft="solar:close-circle-bold">
                Cerrar
            </app-button>
        </div>
    </app-modal>
</div>

<!-- ── Diálogo de Confirmación para Reenvío ── -->
<app-confirm-dialog [(visible)]="showResendConfirm" title="Reenviar Verificación"
    [message]="'¿Estás seguro de que deseas reenviar el correo de activación a ' + (userToResend()?.email || 'este usuario') + '?'"
    (confirm)="confirmResend()" icon="solar:letter-bold-duotone" confirmText="Reenviar Correo" cancelText="Cancelar"
    type="confirmation" [loading]="isResending()"></app-confirm-dialog>